import { Button, Typography } from "antd";
import { PaymentInstrumentDisplay } from "../../../shared/payment/payment-instrument-display";
import { PaymentInstrument } from "../../../../generated";

const { Title } = Typography;

interface PaymentSettingsProps {
  paymentInstrument: PaymentInstrument;
  handleOpen: () => void;
  isDraftMode?: boolean;
}

export const PaymentSettings: React.FC<PaymentSettingsProps> = (props) => {
  if (!props.paymentInstrument.paymentInstrumentId) {
    throw new Error("Payment instrument ID is required");
  }

  const actionButton = (
    <Button
      type="primary"
      onClick={() =>
        props.handleOpen()
      }
    >
      Update Credit Card
    </Button>
  );

  return (
    <div>
      {props.isDraftMode && <Title level={5}>Payment Information</Title>}
      {!props.isDraftMode && <Title level={2}>Payment Settings</Title>}
      <PaymentInstrumentDisplay
        paymentInstrument={props.paymentInstrument}
        actionButton={actionButton}
      />
    </div>
  );
};
